import classNames from 'classnames';
import { IntersectionOptions, useInView } from 'react-intersection-observer';
import { VirtualList, VirtualListProps } from '~/components/List/Virtual/VirtualList';
import styles from './InfiniteList.module.scss';

export type InfiniteListProps = {
  previous?: boolean;
  next?: boolean;
  rootMargin?: IntersectionOptions['rootMargin'];
  onPreviousInView?: () => void;
  onNextInView?: () => void;
} & VirtualListProps;
export const InfiniteList = ({
  className,
  children,
  previous,
  next,
  rootMargin = '100px',
  onPreviousInView,
  onNextInView,
  ...props
}: InfiniteListProps) => {
  const prevInView = useInView({
    rootMargin,
    onChange: (inView) => inView && onPreviousInView?.(),
  });
  const nextInView = useInView({
    rootMargin,
    onChange: (inView) => inView && onNextInView?.(),
  });

  return (
    <VirtualList className={classNames(styles.root, className)} {...props}>
      {previous && (
        <li>
          <div ref={prevInView.ref} className={styles.placeholder}>
            More
          </div>
        </li>
      )}
      {children}
      {next && (
        <li>
          <div ref={nextInView.ref} className={styles.placeholder}>
            More
          </div>
        </li>
      )}
    </VirtualList>
  );
};
